import { lazy } from 'react';

import { retry } from 'src/utils/routing';

export default {
    name: 'browser_fail',
    path: '/',
    component: () => lazy(() => retry(() => import('./index')))
};
